module.exports = __webpack_public_path__ + "img/Scratch.efcf3a78.svg";